import { useParams, Link } from 'react-router-dom';
import { getPostBySlug, blogPosts } from '../data/blogPosts';
import { useEffect } from 'react';

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  useEffect(() => {
    if (post) {
      document.title = post.metaTitle;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute('content', post.metaDescription);
    }
  }, [post]);

  if (!post) {
    return (
      <div style={{ textAlign: 'center', padding: 80 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>404</div>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Blog post not found</div>
        <Link to="/blog" className="btn btn-black">Back to Blog</Link>
      </div>
    );
  }

  const related = blogPosts.filter(p => p.category === post.category && p.slug !== post.slug).slice(0, 3);

  return (
    <div className="fade-up" style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
      <Link to="/blog" style={{ fontSize: 12, color: '#6B7280', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 20 }}>← Back to Blog</Link>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <span className="badge badge-orange">{post.category}</span>
        <span className="badge badge-gray">{post.readTime}</span>
        <span className="badge badge-gray">{post.date}</span>
        <span style={{ fontSize: 11, color: '#6B7280' }}>By {post.author}</span>
      </div>

      <h1 style={{ fontSize: 36, fontWeight: 800, lineHeight: 1.15, letterSpacing: '-0.02em', marginBottom: 20 }}>{post.title}</h1>

      <div style={{ 
        background: 'white', 
        border: '1px solid #E5E7EB', 
        borderRadius: 8, 
        padding: 32,
        fontSize: 15,
        lineHeight: 1.7,
        color: '#111'
      }}>
        <div dangerouslySetInnerHTML={{ 
          __html: post.content
            .split('\n')
            .map(line => {
              if (line.startsWith('# ')) return `<h1 style="font-size:28px;font-weight:800;margin:24px 0 12px;line-height:1.2">${line.slice(2)}</h1>`;
              if (line.startsWith('## ')) return `<h2 style="font-size:22px;font-weight:700;margin:20px 0 10px">${line.slice(3)}</h2>`;
              if (line.startsWith('### ')) return `<h3 style="font-size:16px;font-weight:700;margin:16px 0 8px">${line.slice(4)}</h3>`;
              if (line.startsWith('|')) return ''; // skip tables for simplicity
              if (line.startsWith('- ')) return `<li style="margin:6px 0">${line.slice(2)}</li>`;
              if (line.startsWith('> ')) return `<blockquote style="border-left:3px solid #FF642D;padding:8px 16px;background:#FFF0EB;margin:12px 0;border-radius:0 6px 6px 0">${line.slice(2)}</blockquote>`;
              if (line.trim() === '') return '<br/>';
              if (line.startsWith('[') && line.includes('](')) {
                const match = line.match(/\[(.*?)\]\((.*?)\)/);
                if (match) return `<a href="${match[2]}" style="color:#FF642D;font-weight:600">${match[1]}</a>`;
              }
              return `<p style="margin:12px 0">${line}</p>`;
            })
            .join('')
        }} />
      </div>

      <div style={{ marginTop: 32, padding: 20, background: '#111', color: 'white', borderRadius: 12, textAlign: 'center' }}>
        <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 8 }}>Ready to rank higher?</div>
        <div style={{ fontSize: 13, color: '#9CA3AF', marginBottom: 16 }}>Use Sungresh real data tools to find keywords, analyze backlinks, audit site</div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/keywords/magic" className="btn" style={{ background: '#FF642D', color: 'white' }}>Find Keywords</Link>
          <Link to="/domain/overview" className="btn btn-white">Analyze Domain</Link>
          <Link to="/audit/site" className="btn btn-white">Audit Site</Link>
        </div>
      </div>

      {related.length > 0 && (
        <div style={{ marginTop: 32 }}>
          <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 12 }}>Related Articles</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
            {related.map(p => (
              <Link key={p.slug} to={`/blog/${p.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="card" style={{ margin: 0 }}>
                  <div style={{ fontSize: 11, color: '#FF642D', fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>{p.category}</div>
                  <div style={{ fontWeight: 700, fontSize: 13, lineHeight: 1.3 }}>{p.title}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      <div style={{ marginTop: 32, padding: 16, background: '#FAFBFC', border: '1px solid #E5E7EB', borderRadius: 8, fontSize: 12, color: '#6B7280' }}>
        <div style={{ fontWeight: 700, color: '#111', marginBottom: 6 }}>About Sungresh Blog</div>
        SEO blog + AI Search blog. We write about keyword research, backlink analysis, technical SEO, and AI Search Optimization (AEO) to help you rank on Google AND ChatGPT/Perplexity. All articles optimized with real DataForSEO keyword data.
      </div>
    </div>
  );
}
